<template>
  <v-container

    >
      <v-row
        justify="center"
      >
      <v-col cols="6"
          align-self="center">
          <v-img src="@/assets/logo_bbfw22.png"></v-img>
        </v-col> 
    </v-row>
    <v-row
        justify="center"
      >
      <v-col cols="6"
          align-self="center">
          <v-autocomplete
            v-model="country"
            :items="countryOpts"
            item-text="comment"
            item-value="value"
            label="Your country"
          ></v-autocomplete>
        </v-col> 
    </v-row>
      <v-row
        justify="center"
      >
      <v-col cols="6"
          align-self="center">
          <v-autocomplete
            v-model="age"
            :items="ageOpts"
            item-text="comment"
            item-value="value"
            label="Your age"
          ></v-autocomplete>
        </v-col>        
    </v-row>
    <v-row
        justify="center"
      >
      <v-col cols="6"
          align-self="center">
          <v-autocomplete
            v-model="gender"
            :items="genderOpts"
            item-text="comment"
            item-value="value"
            label="Your gender"
          ></v-autocomplete>
        </v-col>        
    </v-row>
    <v-row
        justify="center"
      >
      <v-col cols="6"
          align-self="center"
          class="text-center"
          >          
          <v-btn block
            elevation="2"
            v-on:click="createUser()"
          >ENTER</v-btn>
        </v-col>        
    </v-row>
    
  </v-container>
</template>

<script>
import countries from '../tools/countries'
import countryCodes from '../tools/countryCodes'
import ages from '../tools/age'
import genders from '../tools/gender'
import { v4 as uuidv4 } from 'uuid'
import * as Api from '../tools/api'

  export default {
    name: 'Form',
    props:['interaction','brand_id','show','userId'],
    data: () => ({
        country: {},
        age:{},
        gender:{}
    }),
    mounted(){
      
    },
    methods:{
      async createUser(){
        let uuid = uuidv4()
        try {
          let response = await Api.openLogin(uuid,this.gender,this.age,this.country)            
          console.log("Open Login Response",response)  
          let response_uid = await Api.getUserId(uuid)
          if(response_uid.users.length > 0){
            console.log("GetUserId Response",response_uid.users[0].id)            
            this.$emit('update:userId', response_uid.users[0].id)            
          }
        } catch (error) {
          console.log("Error",error)
        }                
      }
    },
    computed:{
        countryOpts(){
            return countries.map(c => {
                let newObj = {}
                newObj.comment = countryCodes[c.value]
                newObj.value = c.value
                return newObj
                })
        },
        ageOpts(){
            return ages
        },
        genderOpts(){
            return genders
        }
    }
  }
</script>
